import { getUuid } from '@/utils/commonUtil'
import { getDateYYYYMMDDHHMISS } from '@/utils/dateUtil'
import config from '@/conf/config'

export function getHeader() {
    // 这里可以添加token等认证信息
    const token = localStorage.getItem('token')
    let authorization = ""
    if (token) {
        authorization = `Bearer ${token}`
    }
    // 优先从本地缓存获取登录用户ID，避免请求头中user-id固定为-1导致后端权限查询异常
    let userId = '-1';
    try {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        if (user && user.userId) {
            userId = user.userId;
        }
    } catch (e) {
        console.error('解析用户信息失败', e);
    }
    return {
        Authorization: authorization, // Adjust as needed
        'app-id': config.appId,
        'TRANSACTION-ID': getUuid(),
        'REQ-TIME': getDateYYYYMMDDHHMISS(),
        'SIGN': '',
        'user-id': userId
    }
}